import React from "react";
import {
    Form,
    Input,
    Button
} from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { login } from "../redux/slices/userSlice";
import Background from "../images/mission2.png";
import "../styles/sign.css";

const Sign = props => {
    const dispatch = useDispatch();
    const {
        title,
        type,
        formComplete,
        errorMessage,
        loading,
        email,
        // subtitle
    } = props;

    let buttonText;
    let oppositeTitle;
    let oppositePage;
    if (title === "Auditor Sign Up") {
        buttonText = "Sign Up";
        oppositeTitle = "Login";
        oppositePage = "/login";
    } else if (title === "Auditor Login") {
        buttonText = "Login";
        oppositeTitle = "Sign Up";
        oppositePage = "/signup";
    } else if (title === "Confirm Sign Up") {
        buttonText = "Confirm";
    }
    
    return (
        <div
            className="sign-background"
            style={{
                backgroundImage: `url(${Background})`,
                backgroundPosition: "right",
                backgroundRepeat: "no-repeat"
            }}
        >
            <div className="sign-outer-container">
                <div className="sign-inner-container">
                    <div className="sign-header">
                        <div>
                            <h1>{title}</h1>
                            <p>Cloud Infrastructure Security and Compliance Starts Here </p>
                        </div>
                    </div>
                    <div className="sign-body">
                        {type === "signup_success" ? (
                            <div className="sign-signup-success">
                                <h2>Thank you!</h2>
                                <p>
                                    We are sending you a verification email at
                                    <br/><strong>{email}</strong>.
                                    Please follow the link in the email to complete your sign up.
                                </p>
                            </div>
                        ) : type === "signup_confirm_success-login_true" ? (
                            <div className="sign-signup-success">
                                <h2>Thank you!</h2>
                                <p>
                                    Your account is ready to use.
                                </p>
                                <Button
                                    type="primary"
                                    className="login-form-button"
                                    onClick={() => dispatch(login())}
                                >
                                    Continue to Dashboard
                                </Button>
                            </div>
                        ) : type === "signup_confirm_success-login_false" ? (
                            <div className="sign-signup-success">
                                <h2>Thank you!</h2>
                                <p>
                                    Your account is ready to use.
                                </p>
                                <Link to="/login">
                                    <Button
                                        type="primary"
                                        className="login-form-button"
                                    >
                                        Continue to Login
                                    </Button>
                                </Link>
                            </div>
                        ) : (
                            <>
                                <Form
                                    name="sign_form"
                                    initialValues={{ remember: true }}
                                    onFinish={formComplete}
                                >
                                    <Form.Item
                                        name="email"
                                        rules={[
                                            {
                                                pattern: /^[a-zA-Z0-9]+(?:[._+-][a-zA-Z0-9]+)*@(?!-)[a-zA-Z0-9-]+(?:[.][a-zA-Z0-9-]+)*(?<!-)(?:\.[a-zA-Z]{2,})$/,
                                                message: "Please enter a valid email"
                                              },
                                            { 
                                                required: true, 
                                                message: 'Please enter the email' }]}
                                    >
                                        <Input
                                            prefix={<UserOutlined className="site-form-item-icon" />}
                                            placeholder="Email"
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="password"
                                        rules={[{ required: true, message: 'Please enter the password' }]}
                                    >
                                        <Input
                                            prefix={<LockOutlined className="site-form-item-icon" />}
                                            type="password"
                                            placeholder="Password"
                                        />
                                    </Form.Item>
                                    {type === "signup" ? (
                                        <Form.Item
                                            name="retype_password"
                                            rules={[{ required: true, message: 'Please retype the password' }]}
                                        >
                                            <Input
                                                prefix={<LockOutlined className="site-form-item-icon" />}
                                                type="password"
                                                placeholder="Retype Password"
                                            />
                                        </Form.Item>
                                    ) : null}
                                    {errorMessage !== "" ? (
                                        <div
                                            className="ant-form-item-explain-error"
                                            style={{ marginBottom: "6px" }}
                                        >
                                            {errorMessage}
                                        </div>
                                    ) : null}
                                    <Form.Item>
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            className="login-form-button"
                                            loading={loading}
                                        >
                                            {buttonText}
                                        </Button>
                                    </Form.Item>
                                </Form>
                                {oppositePage ? (
                                    <Link to={oppositePage}>{oppositeTitle}</Link>
                                ) : null}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Sign